module.exports = __webpack_public_path__ + "img/270.d4c3dc85.png";